<template>
    <div class="register-form-container">
        <h2 class="register-title">Регистрация нового пользователя</h2>
        <p class="register-description">
            Присоединяйтесь к платформе Hr3!<br />
            Найдите работу мечты или найдите идеального сотрудника.<br />
            Введите данные ниже, чтобы создать аккаунт.
        </p>
        <div class="input-container">

        <!-- Фейковые поля для ловли автозаполнения -->
        <input
            type="text"
            name="fake_username"
            autocomplete="username"
            style="display:none"
        />

        <input
            type="password"
            name="fake_password"
            autocomplete="current-password"
            style="display:none"
        />

        <TextField
            placeholder="Email"
            v-model="email"
            name="register_email"
            autocomplete="new-email"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            @input="validateEmail"
            :class="{ 'input-error': emailError }"
        />
        <p v-if="emailError" class="error-message">
            Введите корректный email
        </p>

        <TextField
            placeholder="Пароль"
            type="password"
            v-model="password"
            name="register_password"
            autocomplete="new-password"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            @input="validatePassword"
            :class="{ 'input-error': passwordError }"
        />
        <p v-if="passwordError" class="error-message">
            Пароль должен быть не менее 8 символов
        </p>

        <TextField
            placeholder="Подтвердите пароль"
            type="password"
            v-model="confirmPassword"
            name="register_password_confirm"
            autocomplete="new-password"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            @input="validateConfirmPassword"
            :class="{ 'input-error': confirmPasswordError }"
        />
        <p v-if="confirmPasswordError" class="error-message">
            Пароли не совпадают
        </p>

        </div>

        <button class="register-button" :disabled="!isRegisterEnabled" @click="emitRegister">
            Зарегистрироваться
        </button>

        <p v-if="!hasErrors" class="support-text">
            Любые вопросы с учетной записью? <br />
            Пишите нам: <a href="mailto:ceo@hr3.space">tech@hr3.space</a>
        </p>
    </div>
</template>

<script setup>

import { ref, computed, defineEmits } from "vue";
import TextField from "../TextField.vue";

const emit = defineEmits(["register"]);

const email = ref("");
const password = ref("");
const confirmPassword = ref("");

const emailError = ref(false);
const passwordError = ref(false);
const confirmPasswordError = ref(false);

const validateEmail = () => {
    emailError.value = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value);
};

const validatePassword = () => {
    passwordError.value = password.value.length < 8;
};

const validateConfirmPassword = () => {
    confirmPasswordError.value = password.value !== confirmPassword.value;
};

const isRegisterEnabled = computed(() => {
    return email.value && password.value && confirmPassword.value &&
        !emailError.value && !passwordError.value && !confirmPasswordError.value;
});

const hasErrors = computed(() => emailError.value || passwordError.value || confirmPasswordError.value);

const emitRegister = () => {
    console.log("📝 Регистрация прошла успешно!");
    console.log("Email:", email.value);
    console.log("Пароль:", password.value);
    emit("register", { email: email.value, password: password.value });
};

</script>

<style scoped>
.register-form-container {
  width: 385px;
  height: 550px;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 20px;

  border-radius: 15px;

  background-color: #2b2b2b;
}

.register-title {
  margin-top: 20px;
  margin-bottom: 10px;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: -0.3px;
  text-align: center;

  color: white;
}

.register-description {
  max-width: 80%;

  margin-bottom: 40px;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: -0.3px;
  text-align: center;

  color: white;
}

.input-container {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 10px;
}

.input-error {
  border: 1px solid rgba(255, 93, 93, 0.75) !important;

  box-shadow:
    0 0 0 3px rgba(255, 77, 77, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.error-message {
  width: fit-content;
  max-width: 280px;
  min-height: 24px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  margin: 0;
  padding: 4px 10px;

  border: 1px solid rgba(255, 92, 92, 0.18);
  border-radius: 12px;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 10px;
  line-height: 1.25;
  letter-spacing: -0.2px;
  text-align: center;

  color: #ff8d8d;

  background: rgba(255, 77, 77, 0.1);

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.03);

  animation: errorAppear 0.2s ease;
}

@keyframes errorAppear {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.register-button {
  position: relative;

  width: 260px;
  height: 50px;

  overflow: hidden;

  margin-top: 40px;
  margin-bottom: 20px;

  border: 1px solid rgba(99, 164, 255, 0.2);
  border-radius: 25px;

  font-family: "Eastman-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: -0.3px;

  color: white;

  background:
    linear-gradient(
      110deg,
      #2887f7 0%,
      #2173e5 48%,
      #204f90 100%
    );

  box-shadow:
    0 10px 24px rgba(33, 115, 229, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.16);

  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease,
    color 0.2s ease;
}

.register-button::before {
  content: "";

  position: absolute;

  top: -30%;
  bottom: -30%;
  left: -45%;

  width: 32%;

  pointer-events: none;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );

  transform: skewX(-20deg);

  transition: left 0.55s ease;
}

.register-button:hover:not(:disabled) {
  transform: translateY(-2px);

  box-shadow:
    0 14px 30px rgba(33, 115, 229, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.register-button:hover:not(:disabled)::before {
  left: 120%;
}

.register-button:active:not(:disabled) {
  transform: translateY(0) scale(0.985);
}

.register-button:disabled {
  color: rgba(255, 255, 255, 0.34);

  cursor: not-allowed;

  border-color: rgba(255, 255, 255, 0.04);

  background:
    linear-gradient(
      180deg,
      #474747 0%,
      #3d3d3d 100%
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.04);

  opacity: 1;
}

.register-button:disabled::before {
  display: none;
}

.support-text {
  margin-top: 15px;

  font-family: "Eastman-Regular", sans-serif;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;

  color: white;
}

.support-text a {
  font-family: "Eastman-Bold", sans-serif;

  color: #2887f7;

  text-decoration: none;
}

.support-text a:hover {
  text-decoration: underline;
}

[data-theme="light"] .register-form-container {
  background-color: #f7f7f7;
}

[data-theme="light"] .register-title,
[data-theme="light"] .register-description,
[data-theme="light"] .support-text {
  color: #111111;
}

[data-theme="light"] .error-message {
  color: #d74444;

  border-color: rgba(214, 68, 68, 0.15);

  background: rgba(214, 68, 68, 0.07);
}

[data-theme="light"] .register-button {
  color: white;

  background:
    linear-gradient(
      110deg,
      #2887f7 0%,
      #2173e5 48%,
      #204f90 100%
    );
}

[data-theme="light"] .register-button:disabled {
  color: rgba(17, 17, 17, 0.3);

  border-color: rgba(0, 0, 0, 0.04);

  background:
    linear-gradient(
      180deg,
      #dedede 0%,
      #d3d3d3 100%
    );

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.6);

  opacity: 1;
}

[data-theme="light"] .support-text a {
  color: #2173e5;
}

@media (max-width: 768px) {
  .register-form-container {
    width: 340px;
    height: auto;

    padding: 18px;
  }

  .register-title {
    font-size: 13px;
  }

  .register-description {
    margin-bottom: 30px;

    font-size: 11px;
  }

  .register-button {
    width: 220px;
    height: 46px;

    margin-top: 30px;
  }

  .support-text {
    font-size: 11px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .register-button,
  .register-button::before,
  .error-message {
    animation: none !important;
    transition: none !important;
  }
}
</style>